<div class="retailer-commission-container">
  <div class="section-menu-items">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['updateretailer',retailerId]"
        routerLinkActive="router-link-active"
      >
      <span translate class="translate"> pages.newRetailer.editRetailer</span
        ><mat-icon class="ms-2">add_box</mat-icon>
      </button>
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['transactions',retailerId]"
        routerLinkActive="router-link-active"
      >
      <span translate class="translate">pages.newRetailer.transactionHistory</span><mat-icon class="ms-2"
          >restore</mat-icon
        >
      </button>
      <button
      mat-flat-button
      class="item-each"
      [routerLink]="['payment-history',retailerId]"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'Payment History per retailer'"
      >
      <span translate class="translate">pages.newRetailer.paymentHistory</span><mat-icon class="ms-2"
          >credit_card</mat-icon
        >
      </button>
      <button
      mat-flat-button
      class="item-each"
      [routerLink]="['comments',retailerId]"
      routerLinkActive="router-link-active"
      >
      <span translate class="translate">pages.newRetailer.comments</span><mat-icon class="ms-2"
          >credit_card</mat-icon
        >
      </button>    
    </div>
    <router-outlet></router-outlet>
  </div>